import { DataTableSchema, DefaultTableSchema, TableColumnSchema } from "./dynamic-data-table.model";
import { AreaMutipleSelect, DistrictMutipleSelect, defaultSearchContainerButtons, ReportOwnerDropdown, DealerDropdown, JobCodeDescriptionDropdown, ReportNameDropdown, EventNameDropdown, CompletionDateDate, FieldNames, StartDateDate } from "./form-fields.model";
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig } from "./form.model";
import { FETCH_METHODS } from "./common.model";
import { SearchConfig } from "./api.model";

export const GoogleAnalyticsTitle = "Lexus Learn Analytics";

export const GoogleAnalyticsSearchConfig: SearchConfig = {
    path: 'fetchElevateReport',
    method: FETCH_METHODS['Post'],
    body: {
        [FieldNames['ReportName']]: "",
        [FieldNames['ReportOwner']]: "",
        [FieldNames['StartDate']]: "",
        [FieldNames['endDate']]: "",
        "is_ui":true,
    }
}

export const GoogleAnalyticsReportOwnersSearchConfig: SearchConfig = {
    path: 'getLexusReportOwners',
    method: FETCH_METHODS['Get']
}

export const GoogleAnalyticsDealerOptionsSearchConfig: SearchConfig = {
    path: 'distributionListDropdown',
    method: FETCH_METHODS['Get'],
    body: {}
}

export const GoogleAnalyticsJobCodeOptionsSearchConfig: SearchConfig = {
    path: 'getElitePrimaryJobList',
    method: FETCH_METHODS['Get']
}

const now = new Date();
const currentMonthStartDate = new Date(now.getFullYear(), now.getMonth(), 1);
const currentMonthEndDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
const formatDateToISO = (date: Date): string =>
    `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

const GoogleAnalyticsAreaOptions = [
    { fieldLabel: 'Western Area', fieldValue: 'Western Area' },
    { fieldLabel: 'Central Area', fieldValue: 'Central Area' },
    { fieldLabel: 'Eastern Area', fieldValue: 'Eastern Area' },
    { fieldLabel: 'Southern Area', fieldValue: 'Southern Area' },
];

const GoogleAnalyticsDistrictOptions = [
    { fieldLabel: '1', fieldValue: '1' },
    { fieldLabel: '2', fieldValue: '2' },
    { fieldLabel: '3', fieldValue: '3' },
    { fieldLabel: '4', fieldValue: '4' },
    { fieldLabel: '5', fieldValue: '5' },
    { fieldLabel: '6', fieldValue: '6' },
];

const GoogleAnalyticsEventNameOptions = [
    { fieldLabel: 'hometile_view', fieldValue: 'hometile_view' },
    { fieldLabel: 'page_view', fieldValue: 'page_view' },
    { fieldLabel: 'playerPlayed', fieldValue: 'playerPlayed' },
];

export const GoogleAnalyticsReportOwnerNameMap: Array<{ reportOwner: string, reportName: string }> = [
    { reportOwner: 'Gary Botka', reportName: 'lexus-learn-lfs-report' },
    { reportOwner: 'Vincent Salisbury', reportName: 'elevate-report' },
];

const FormFieldArray: FormFieldConfig[] = structuredClone([
    {
        ...structuredClone(StartDateDate),
        displayName: 'From Date',
        defaultValue: formatDateToISO(currentMonthStartDate),
        selectedValue: currentMonthStartDate,
    },
    {
        ...structuredClone(CompletionDateDate),
        fieldName: FieldNames.endDate,
        displayName: 'To Date',
        defaultValue: formatDateToISO(currentMonthEndDate),
        selectedValue: currentMonthEndDate,
    },
    { ...structuredClone(ReportNameDropdown), showSelect:false, options: [] },
    {
        ...structuredClone(ReportOwnerDropdown),
        showSelect: false,
        options: [],
    },
    { ...structuredClone(AreaMutipleSelect), options: GoogleAnalyticsAreaOptions },
    { ...structuredClone(DistrictMutipleSelect), options: GoogleAnalyticsDistrictOptions },
    { ...structuredClone(DealerDropdown), isLoading: true, isAutoComplete: true, showSelect: true },
    { ...structuredClone(JobCodeDescriptionDropdown), showSelect: true },
    { ...structuredClone(EventNameDropdown), options: GoogleAnalyticsEventNameOptions },
    ]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);


export const GoogleAnalyticsFilterSchema: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    autoSearchOnLoad: true
}

const GoogleAnalyticsColumnSchema: Array<TableColumnSchema> = [
    { label: 'Report Owner', fieldKey: 'reportOwner', sticky: true },
    { label: 'Area', fieldKey: 'Area' },
    { label: 'District', fieldKey: 'District' },
    { label: 'Dealer', fieldKey: 'Dealer' },
    { label: 'Job', fieldKey: 'Job' },
    { label: 'Event Name', fieldKey: 'Event Name' },
    { label: 'Event Date', fieldKey: 'Event Date' },
    { label: 'Event Count', fieldKey: 'Event Count' },
];

export const GoogleAnalyticsTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: GoogleAnalyticsColumnSchema,
    exportConfig: {
        fileName: 'Google_Analytics_Report',
        exportMessage: GoogleAnalyticsTitle,
        schema: {
            reportOwner: 'Report Owner',
            Area: 'Area',
            District: 'District',
            Dealer: 'Dealer',
            Job: 'Job',
            'Event Name': 'Event Name',
            'Event Date': 'Event Date',
            'Event Count': 'Event Count'
        },
    },
    breadcrums: [{ level: 1, name: GoogleAnalyticsTitle }]
}